document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById("menu-toggle");
  const icon = document.getElementById("burger-icon");
  if (!btn || !icon) return;

  const details = btn.closest("details");
  if (!details) return;

  window.addEventListener('load', function() {
    const lottie = icon.getLottie();
    if (!lottie) return;
    const middle = Math.floor(lottie.totalFrames / 2); // Half of the frames

    let isX = false; // current icon state: false = burger, true = X

    // Sync the icon to the drawer's actual open state so it reverts on
    // every close path (summary click, close button, click outside, Escape),
    // not just when the burger button itself is clicked.
    const syncIcon = () => {
      const open = details.hasAttribute('open');
      if (open === isX) return;

      if (open) {
        lottie.goToAndStop(0, true);
        lottie.playSegments([0, middle], true); // Burger -> X
      } else {
        lottie.goToAndStop(middle, true);
        lottie.playSegments([middle, 0], true); // X -> Burger
      }
      isX = open;
    };

    const observer = new MutationObserver(syncIcon);
    observer.observe(details, { attributes: true, attributeFilter: ['open'] });

    syncIcon();
  });
});
